import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  // {
  //   path: '/login',
  //   name: 'login',
  //   component: () => import('@/views/login.vue')
  // },
  {
    path: '/authorize',
    name: 'authorize',
    component: () => import('@/views/authorize.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login-new.vue')
  }
]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})


export default router
